import { useLoaderData } from "react-router";
import CustomError from "@components/Error/CustomError";
import { MetaDescriptorProps } from "@features/seo/utils/types";
import { Route } from "@route-types/MyAccount/+types/MyAccountPage";
import { fetchMyAccountPageData } from "@routes/MyAccount/MyAccountPage.server";
import MyAccountPageContent from "@routes/MyAccount/MyAccountPageContent";
import { MyAccountPageContext } from "@routes/MyAccount/utils/types";
import { ResponseType } from "@sphtech/web2-core/ssr";
import { createMetaTags } from "@sphtech/web2-seo-schema";
import { HttpStatusCode } from "axios";

/** This is the main entry point component for /my-account route. */
const MyAccountPage = (): React.ReactElement => {
  const context = useLoaderData<MyAccountPageContext>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (typeof context?.payload === "undefined") {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return (
    <MyAccountPageContent
      {...context.payload.data}
      gaProps={context.payload.gaProps}
    />
  );
};

export default MyAccountPage;

export const loader = async () => await fetchMyAccountPageData();

export const meta = ({ loaderData }: Route.MetaArgs): MetaDescriptorProps[] => {
  const context = loaderData as MyAccountPageContext;
  if (context.type !== ResponseType.SUCCESS) return [];

  const data = context.payload;

  if (!data) return [];
  if (!data.metaTags) return [];

  return createMetaTags(data.metaTags);
};
